import {
  Box,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/system';
import { flagDueDelligenceFile, getDueDelligenceFile } from 'api/apiService';
import Loading from 'assets/images/loading.png';
import Pin from 'assets/images/Pin.png';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { CircleDone } from './Marketplaceicons';
import { datacontext } from 'modules/AppLayout/AppLayout';
import Moxochat from 'component/Moxochat/Moxochat';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
export const DueDiligence = ({
  getBuyerIndividualValue,
  groupCall,
  setOpenlogin,
  openlogin,
  sharedpage,
  ApicallDueDiligence,
  loadingDue,
  setLoadingDue,
  dataNotFound,
  data,
  setData,
  setDataNotFound,
}) => {
  const params = useParams();
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const propertyId = params.propertyId;

  const { realTimeLog, setIschatopen } = useContext(datacontext);
  const { setIsBinderChatOpen } = useContext(PropertyContext);
  const [moxochatopen, setMoxochatopen] = useState(false);
  const [strataHover, setStrataHover] = useState(false);
  const [pestHover, setPestHover] = useState(false);
  const currentUrl = window.location.href;
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);

  useEffect(() => {
    ApicallDueDiligence();
  }, []);

  return (
    <Grid
      sx={{
        minWidth: '100%',
        maxWidth: '100%',
        maxHeight: '194px',
        backgroundColor: '#F8F8F8',
        justifyContent: 'center',
        marginTop: 0,
        borderRadius: '5px',
        position: 'relative',
        overflow: 'auto',

        cursor: dataNotFound ? 'not-allowed' : 'initial',
      }}
    >
      {loadingDue ? (
        <Typography
          sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}
        >
          <img
            alt="Logo"
            src={Loading}
            className="loaderImage"
            style={{ height: '100px', width: '100px' }}
          />
        </Typography>
      ) : dataNotFound ||
        (!data?.StrataLink?.propertyMedia &&
          !data?.BuildingPestLink?.propertyMedia) ? (
        <Stack
          direction={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          gap={'10px'}
          width={'100%'}
          height={'100%'}
          sx={{ minHeight: '194px' }}
        >
          <Typography
            sx={{
              height: matchesmd ? '120px' : '40px',
              marginTop: '-5px',
              fontFamily: 'Poppins !important',
              fontStyle: 'normal !important',
              fontWeight: '500 !important',
              fontSize: '16px',
              color: '#6C2AD2',
              cursor: 'none',
              padding: '9px 50px',
              textTransform: 'none',
            }}
          >
            The Building & Pest Report and/or Strata Report have not been
            uploaded to this listing.
          </Typography>
          <Button
            sx={{
              backgroundColor: '#FFFFFF',
              borderRadius: '5px',
              height: matchesmd ? '120px' : '40px',
              marginTop: '-5px',
              fontFamily: 'Poppins !important',
              fontStyle: 'normal !important',
              fontWeight: '500 !important',
              fontSize: '16px',
              color: '#6C2AD2',
              padding: '9px 50px',
              textTransform: 'none',
              border: '1px solid #6C2AD2',
            }}
            onClick={() => {
              if (sharedpage) {
                setOpenlogin(!openlogin);
              } else {
                setIschatopen(
                  getBuyerIndividualValue?.PropertyDetails?.agentBuyerBinderId
                );
                setMoxochatopen(true);
                setIsBinderChatOpen(true);
              }
            }}
          >
            Contact Agent
          </Button>
        </Stack>
      ) : (
        <Table sx={{ opacity: dataNotFound ? '0.6' : 1, width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderBottom: 'none' }}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: '16px',
                    color: '#112347',
                  }}
                >
                  Document
                </Typography>
              </TableCell>
              {!matcheslg && (
                <TableCell sx={{ borderBottom: 'none' }}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '16px',
                      color: '#112347',
                    }}
                  >
                    Supplier
                  </Typography>
                </TableCell>
              )}
              {!matcheslg && (
                <TableCell sx={{ borderBottom: 'none' }}>
                  {' '}
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '16px',
                      color: '#112347',
                    }}
                  >
                    Link
                  </Typography>
                </TableCell>
              )}
              <TableCell sx={{ borderBottom: 'none' }}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: '16px',
                    color: '#112347',
                  }}
                >
                  Status
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.StrataLink?.propertyMedia && (
              <TableRow sx={{ borderTop: '1px solid lightgrey' }}>
                <TableCell
                  sx={{
                    borderBottom: 'none',
                    display: matcheslg && 'flex',
                    flexDirection: matcheslg && 'column',
                    gap: '20px',
                  }}
                >
                  <Stack flexDirection={'row'}>
                    <img
                      src={Pin}
                      alt="Pin"
                      style={{
                        width: '21px',
                        height: '21px',
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '16px',
                        color: '#666666',
                        whiteSpace: 'nowrap',
                        marginLeft: '5px',
                      }}
                    >
                      Strata Report
                    </Typography>
                  </Stack>

                  {matcheslg && (
                    <a
                      href={!sharedpage && data?.StrataLink?.propertyMedia}
                      target="_blank"
                    >
                      <Box
                        component={Button}
                        onMouseEnter={() => setStrataHover(true)}
                        onMouseLeave={() => setStrataHover(false)}
                        onClick={() => {
                          if (data?.StrataLink?.propertyMedia) {
                            if (sharedpage) {
                              setOpenlogin(!openlogin);
                            } else {
                              flagDueDelligenceFile(
                                data?.StrataLink?.propertyId,
                                data?.StrataLink?.mediaType
                              ).then((res) => {
                                getDueDelligenceFile(propertyId);
                                groupCall();
                                ApicallDueDiligence();
                              });
                            }
                          }
                        }}
                        sx={{
                          backgroundColor: dataNotFound ? '#ece5f6' : '#6C2AD2',
                          borderRadius: '5px',
                          height: '40px',
                          marginTop: '-5px',
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: matcheslg ? '12px' : '16px',
                          color: dataNotFound ? '#6c2ad2' : '#FFFFFF',
                          padding: '9px 15px',
                          textTransform: 'none',
                          '&:hover': {
                            //you want this to be the same as the backgroundColor above
                            backgroundColor: dataNotFound
                              ? '#ece5f6'
                              : '#6C2AD2',
                          },
                        }}
                      >
                        {strataHover && !data?.StrataLink?.propertyMedia
                          ? 'Request for strata report'
                          : !data?.StrataLink?.propertyMedia
                          ? 'No report linked'
                          : 'View'}
                      </Box>
                    </a>
                  )}
                  {matcheslg && (
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '16px',
                        color: '#666666',
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      Supplier : Agent
                    </Typography>
                  )}
                </TableCell>
                {!matcheslg && (
                  <TableCell sx={{ borderBottom: 'none' }}>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '16px',
                        color: '#666666',
                      }}
                    >
                      Agent
                    </Typography>
                  </TableCell>
                )}

                {!matcheslg && (
                  <TableCell sx={{ borderBottom: 'none' }}>
                    <a
                      href={!sharedpage && data?.StrataLink?.propertyMedia}
                      target="_blank"
                    >
                      <Box
                        component={Button}
                        onMouseEnter={() => setStrataHover(true)}
                        onMouseLeave={() => setStrataHover(false)}
                        onClick={() => {
                          if (data?.StrataLink?.propertyMedia) {
                            if (sharedpage) {
                              setOpenlogin(!openlogin);
                            } else {
                              flagDueDelligenceFile(
                                data?.StrataLink?.propertyId,
                                data?.StrataLink?.mediaType
                              ).then((res) => {
                                getDueDelligenceFile(propertyId);
                                groupCall();
                                ApicallDueDiligence();
                              });
                            }
                          }
                        }}
                        sx={{
                          backgroundColor: dataNotFound ? '#ece5f6' : '#6C2AD2',
                          borderRadius: '5px',
                          height: '40px',
                          marginTop: '-5px',
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: '16px',
                          color: dataNotFound ? '#6c2ad2' : '#FFFFFF',
                          padding: '9px 50px',
                          textTransform: 'none',
                          '&:hover': {
                            //you want this to be the same as the backgroundColor above
                            backgroundColor: dataNotFound
                              ? '#ece5f6'
                              : '#6C2AD2',
                          },
                        }}
                      >
                        {strataHover && !data?.StrataLink?.propertyMedia
                          ? 'Request for strata report'
                          : !data?.StrataLink?.propertyMedia
                          ? 'No report linked'
                          : 'View'}
                      </Box>
                    </a>
                  </TableCell>
                )}
                <TableCell sx={{ borderBottom: 'none', textAlign: 'left' }}>
                  <Box
                    sx={{ marginLeft: '15px', marginTop: matcheslg && '-55px' }}
                  >
                    <CircleDone
                      color={
                        data?.StrataLink?.isDone == '1' ? '#10D35E' : 'grey'
                      }
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
            {data?.BuildingPestLink?.propertyMedia && (
              <TableRow sx={{ borderTop: '1px solid lightgrey' }}>
                <TableCell
                  sx={{
                    borderBottom: 'none',
                    display: matcheslg && 'flex',
                    flexDirection: matcheslg && 'column',
                    gap: '20px',
                  }}
                >
                  <Stack flexDirection={'row'}>
                    <img
                      src={Pin}
                      alt="Pin"
                      style={{
                        width: '21px',
                        height: '21px',
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '16px',
                        color: '#666666',
                        whitespace: 'nowrap',
                        marginLeft: '5px',
                      }}
                    >
                      {matchessm ? 'PEST' : 'Pest Report'}
                    </Typography>
                  </Stack>

                  {matcheslg && (
                    <a
                      href={
                        !sharedpage && data?.BuildingPestLink?.propertyMedia
                      }
                      target="_blank"
                    >
                      <Box
                        component={Button}
                        onMouseEnter={() => setPestHover(true)}
                        onMouseLeave={() => setPestHover(false)}
                        sx={{
                          backgroundColor: dataNotFound ? '#ece5f6' : '#6C2AD2',
                          borderRadius: '5px',
                          height: '40px',
                          marginTop: '-5px',
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: matcheslg ? '12px' : '16px',
                          color: dataNotFound ? '#6c2ad2' : '#FFFFFF',
                          padding: '9px 15px',
                          textTransform: 'none',
                          '&:hover': {
                            //you want this to be the same as the backgroundColor above
                            backgroundColor: dataNotFound
                              ? '#ece5f6'
                              : '#6C2AD2',
                          },
                        }}
                        onClick={() => {
                          if (data?.BuildingPestLink?.propertyMedia) {
                            if (sharedpage) {
                              setOpenlogin(!openlogin);
                            } else {
                              flagDueDelligenceFile(
                                data?.BuildingPestLink?.propertyId,
                                data?.BuildingPestLink?.mediaType
                              ).then((res) => {
                                getDueDelligenceFile(propertyId);
                                groupCall();
                                ApicallDueDiligence();
                              });
                            }
                          }
                        }}
                      >
                        {pestHover && !data?.BuildingPestLink?.propertyMedia
                          ? 'Request for Pest Link'
                          : !data?.BuildingPestLink?.propertyMedia
                          ? 'No report linked'
                          : 'View'}
                      </Box>
                    </a>
                  )}
                  {matcheslg && (
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '16px',
                        color: '#666666',
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      Supplier : Agent
                    </Typography>
                  )}
                </TableCell>
                {!matcheslg && (
                  <TableCell sx={{ borderBottom: 'none' }}>
                    {' '}
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '16px',
                        color: '#666666',
                      }}
                    >
                      Agent
                    </Typography>
                  </TableCell>
                )}
                {!matcheslg && (
                  <TableCell sx={{ borderBottom: 'none' }}>
                    <a
                      href={
                        !sharedpage && data?.BuildingPestLink?.propertyMedia
                      }
                      target="_blank"
                    >
                      <Box
                        component={Button}
                        onMouseEnter={() => setPestHover(true)}
                        onMouseLeave={() => setPestHover(false)}
                        sx={{
                          backgroundColor: dataNotFound ? '#ece5f6' : '#6C2AD2',
                          borderRadius: '5px',
                          height: '40px',
                          marginTop: '-5px',
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: '16px',
                          color: dataNotFound ? '#6c2ad2' : '#FFFFFF',
                          padding: '9px 50px',
                          textTransform: 'none',
                          '&:hover': {
                            //you want this to be the same as the backgroundColor above
                            backgroundColor: dataNotFound
                              ? '#ece5f6'
                              : '#6C2AD2',
                          },
                        }}
                        onClick={() => {
                          if (data?.BuildingPestLink?.propertyMedia) {
                            if (sharedpage) {
                              setOpenlogin(!openlogin);
                            } else {
                              flagDueDelligenceFile(
                                data?.BuildingPestLink?.propertyId,
                                data?.BuildingPestLink?.mediaType
                              ).then((res) => {
                                getDueDelligenceFile(propertyId);
                                groupCall();
                                ApicallDueDiligence();
                              });
                            }
                          }
                        }}
                      >
                        {pestHover && !data?.BuildingPestLink?.propertyMedia
                          ? 'Request for Pest Link'
                          : !data?.BuildingPestLink?.propertyMedia
                          ? 'No report linked'
                          : 'View'}
                      </Box>
                    </a>
                  </TableCell>
                )}
                <TableCell sx={{ borderBottom: 'none', textAlign: 'left' }}>
                  <Box
                    sx={{ marginLeft: '15px', marginTop: matcheslg && '-55px' }}
                  >
                    <CircleDone
                      color={
                        data?.BuildingPestLink?.isDone == '1'
                          ? '#10D35E'
                          : 'grey'
                      }
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}

      {moxochatopen && (
        <Moxochat open={moxochatopen} onClose={setMoxochatopen} />
      )}
    </Grid>
  );
};
